import React from "react";
import PropTypes from "prop-types";
import SvgIcon from "@mui/material/SvgIcon";

export default function LoadBookingIcon(props) {
  return (
    <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path d="M10.0001 17.0834C9.01716 17.0834 8.09622 16.8975 7.23725 16.5257C6.37828 16.1539 5.62934 15.6485 4.99046 15.0097C4.35158 14.3708 3.84625 13.6218 3.47446 12.7629C3.10265 11.9039 2.91675 10.983 2.91675 10.0001C2.91675 9.01716 3.10265 8.09622 3.47446 7.23725C3.84625 6.37828 4.35158 5.62935 4.99046 4.99046C5.62934 4.35158 6.37828 3.84625 7.23725 3.47446C8.09622 3.10265 9.01716 2.91675 10.0001 2.91675V4.16673C8.37506 4.16673 6.99659 4.7327 5.86464 5.86464C4.7327 6.99659 4.16673 8.37506 4.16673 10.0001C4.16673 11.6251 4.7327 13.0035 5.86464 14.1355C6.99659 15.2674 8.37506 15.8334 10.0001 15.8334V17.0834ZM13.3334 13.8702L12.4552 12.9792L14.8174 10.625H7.70841V9.37508H14.8094L12.4552 7.00006L13.3334 6.12989L17.2036 10.0001L13.3334 13.8702Z" fill={props.color}/>
    </SvgIcon>
  );
}

LoadBookingIcon.propTypes = {
  color: PropTypes.string
};